import { render } from "./SiderMenuItem.vue?vue&type=template&id=634e6256&ts=true"
import script from "./SiderMenuItem.vue?vue&type=script&lang=ts"
export * from "./SiderMenuItem.vue?vue&type=script&lang=ts"

import "./SiderMenuItem.vue?vue&type=style&index=0&id=634e6256&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__